(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/endpoints/search-api.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/endpoints/search-api.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const jupiterFetch = svs.core.jupiterFetch;
const svsFetch = svs.core.svsFetch.create();
const casinoMicroserviceSocket = svs.core.svsSocket.get('/v1/casino-socket');
const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
const _RTKQ = RTKQ,
  fetchBaseQuery = _RTKQ.fetchBaseQuery,
  createApi = _RTKQ.createApi;
const _svs$components$casin = svs.components.casino_react.common,
  CardType = _svs$components$casin.constants.CardType,
  normalizeCardData = _svs$components$casin.utils.normalizeCardData;

function serializeWithoutPaging(endpointName) {
  let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const searchQuery = args.searchQuery,
    tags = args.tags,
    categories = args.categories,
    providers = args.providers,
    sorting = args.sorting,
    listIds = args.listIds,
    listId = args.listId;
  const params = new URLSearchParams();
  params.append('endpoint', endpointName);
  if (searchQuery) {
    params.append('query', searchQuery);
  }
  if (tags !== null && tags !== void 0 && tags.length) {
    params.append('tags', tags.join(','));
  }
  if (categories !== null && categories !== void 0 && categories.length) {
    params.append('categories', categories.join(','));
  }
  if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
    const _sorting$split = sorting.split('-'),
      _sorting$split2 = _slicedToArray(_sorting$split, 2),
      orderBy = _sorting$split2[0],
      sortOrder = _sorting$split2[1];
    if (orderBy !== 'default') {
      params.append('orderBy', encodeURIComponent(orderBy));
      params.append('sortOrder', encodeURIComponent(sortOrder));
    }
  }
  if (providers !== null && providers !== void 0 && providers.length) {
    params.append('providers', providers.join(','));
  }
  if (listIds !== null && listIds !== void 0 && listIds.length) {
    params.append('listIds', listIds.join(','));
  }
  if (listId) {
    params.append('listId', listId);
  }
  return params.toString();
}
const getSearchResult = 'getSearchResult';
const getListFilterResult = 'getListFilterResult';
const searchApi = createApi({
  reducerPath: 'SearchAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: jupiterFetch.url(),
    fetchFn: jupiterFetch.fetch
  }),
  endpoints: builder => ({
    [getListFilterResult]: builder.query({
      queryFn: async (_ref, _api, _extraOptions, baseQuery) => {
        let _ref$listId = _ref.listId,
          listId = _ref$listId === void 0 ? '' : _ref$listId,
          _ref$count = _ref.count,
          count = _ref$count === void 0 ? 1000 : _ref$count,
          _ref$offset = _ref.offset,
          offset = _ref$offset === void 0 ? 0 : _ref$offset;
        const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
        if (useLegacyJupiterApi) {
          const qs = new URLSearchParams();
          qs.append('count', encodeURIComponent(count));
          qs.append('offset', encodeURIComponent(offset));
          qs.append('listId', encodeURIComponent(listId));
          qs.append('routesDomain', encodeURIComponent('spela'));
          const result = await baseQuery("/content/2/listfilter?".concat(qs.toString()));
          if (result.error) {
            return result;
          }

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(result.data.result);
          return {
            data: {
              error: result.data.error,
              totalCount: result.data.totalCount,
              games: result.data.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        }

        try {
          const client = svs.content.shared.getCmsClient();
          const response = await client.v1.content.listFilter({
            listIds: listId,
            count,
            offset,
            channels: svs.core.data.capabilities.channel
          });

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(response.result);
          return {
            data: {
              error: null,
              totalCount: response.totalCount,
              games: response.result.map(game => normalizeCardData({
                name: game.name
              }, CardType.GAME))
            }
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      serializeQueryArgs: _ref2 => {
        let endpointName = _ref2.endpointName,
          queryArgs = _ref2.queryArgs;
        return serializeWithoutPaging(endpointName, queryArgs);
      },
      merge: (currentCache, _ref3) => {
        let games = _ref3.games,
          error = _ref3.error,
          totalCount = _ref3.totalCount;
        if (!(currentCache !== null && currentCache !== void 0 && currentCache.games)) {
          currentCache.games = [];
        }
        currentCache.error = error;
        currentCache.totalCount = totalCount;
        const currentlyLoadedGamesList = new Set(currentCache.games.map(game => {
          var _game$model;
          return (_game$model = game.model) === null || _game$model === void 0 ? void 0 : _game$model.name;
        }));
        for (const game of games) {
          var _game$model2;
          if (!currentlyLoadedGamesList.has((_game$model2 = game.model) === null || _game$model2 === void 0 ? void 0 : _game$model2.name)) {
            currentCache.games.push(game);
          }
        }
      },
      forceRefetch(_ref4) {
        let currentArg = _ref4.currentArg,
          previousArg = _ref4.previousArg;
        const cur = serializeWithoutPaging(getListFilterResult, currentArg);
        const prev = serializeWithoutPaging(getListFilterResult, previousArg);
        return cur !== prev;
      }
    }),
    [getSearchResult]: builder.query({
      queryFn: async (_ref5, _api, _extraOptions, baseQuery) => {
        let _ref5$searchQuery = _ref5.searchQuery,
          searchQuery = _ref5$searchQuery === void 0 ? '' : _ref5$searchQuery,
          _ref5$categories = _ref5.categories,
          categories = _ref5$categories === void 0 ? [] : _ref5$categories,
          _ref5$listIds = _ref5.listIds,
          listIds = _ref5$listIds === void 0 ? [] : _ref5$listIds,
          _ref5$providers = _ref5.providers,
          providers = _ref5$providers === void 0 ? [] : _ref5$providers,
          _ref5$tags = _ref5.tags,
          tags = _ref5$tags === void 0 ? [] : _ref5$tags,
          _ref5$count = _ref5.count,
          count = _ref5$count === void 0 ? 1000 : _ref5$count,
          _ref5$offset = _ref5.offset,
          offset = _ref5$offset === void 0 ? 0 : _ref5$offset,
          _ref5$sorting = _ref5.sorting,
          sorting = _ref5$sorting === void 0 ? '' : _ref5$sorting;
        const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
        if (useLegacyJupiterApi) {
          const qs = new URLSearchParams();
          qs.append('count', encodeURIComponent(count));
          qs.append('offset', encodeURIComponent(offset));
          if (typeof searchQuery === 'string' && (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) > 0) {
            qs.append('query', encodeURIComponent(searchQuery));
          }
          if (Array.isArray(categories) && (categories === null || categories === void 0 ? void 0 : categories.length) > 0) {
            qs.append('categories', categories.join(','));
          }
          if (Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0) {
            qs.append('providers', providers.join(','));
          }
          if (Array.isArray(listIds) && (listIds === null || listIds === void 0 ? void 0 : listIds.length) > 0) {
            qs.append('listIds', listIds.join(','));
          }
          if (Array.isArray(tags) && (tags === null || tags === void 0 ? void 0 : tags.length) > 0) {
            qs.append('tags', tags.join(','));
          }
          if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
            const _sorting$split3 = sorting.split('-'),
              _sorting$split4 = _slicedToArray(_sorting$split3, 2),
              orderBy = _sorting$split4[0],
              sortOrder = _sorting$split4[1];
            if (orderBy !== 'default') {
              qs.append('orderBy', encodeURIComponent(orderBy));
              qs.append('sortOrder', encodeURIComponent(sortOrder));
            }
          }
          qs.append('routesDomain', encodeURIComponent('spela'));
          const queryArray = [];
          qs.forEach((val, key) => {
            if (key === 'routesDomain') {
              queryArray.push("".concat(key, "=").concat(val));
            } else {
              queryArray.push("".concat(key, "=").concat(val, "&"));
            }
          });
          const result = await baseQuery("/content/4/casinosearch?".concat(queryArray.join('')));
          if (result.error) {
            return result;
          }

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(result.data.result);
          return {
            data: {
              error: result.data.error,
              totalCount: result.data.totalCount,
              games: result.data.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        }

        try {
          const client = svs.content.shared.getCmsClient();
          const sort = [];
          if (typeof sorting === 'string' && (sorting === null || sorting === void 0 ? void 0 : sorting.length) > 0) {
            const _sorting$split5 = sorting.split('-'),
              _sorting$split6 = _slicedToArray(_sorting$split5, 2),
              orderBy = _sorting$split6[0],
              sortOrder = _sorting$split6[1];
            if (orderBy !== 'default') {
              sort.push("".concat(orderBy, ";").concat(sortOrder));
            }
          }
          const response = await client.v1.content.casinoSearch({
            query: typeof searchQuery === 'string' && (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) > 0 ? searchQuery : undefined,
            categories: Array.isArray(categories) && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 ? categories.join(',') : undefined,
            providers: Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 ? providers.join(',') : undefined,
            tags: Array.isArray(tags) && (tags === null || tags === void 0 ? void 0 : tags.length) > 0 ? tags.join(',') : undefined,
            listIds: Array.isArray(listIds) && (listIds === null || listIds === void 0 ? void 0 : listIds.length) > 0 ? listIds.join(',') : undefined,
            sort: sort.length > 0 ? sort : undefined,
            count,
            offset
          });

          svs.components.casino_react.ClientGamecache.getClientGamecache().addToCache(response.result);
          return {
            data: {
              error: null,
              totalCount: response.totalCount,
              games: response.result.map(game => normalizeCardData({
                name: game.name
              }, CardType.GAME))
            }
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      serializeQueryArgs: _ref6 => {
        let endpointName = _ref6.endpointName,
          queryArgs = _ref6.queryArgs;
        return serializeWithoutPaging(endpointName, queryArgs);
      },
      merge: (currentCache, _ref7) => {
        let games = _ref7.games,
          error = _ref7.error,
          totalCount = _ref7.totalCount;
        if (!(currentCache !== null && currentCache !== void 0 && currentCache.games)) {
          currentCache.games = [];
        }
        currentCache.error = error;
        currentCache.totalCount = totalCount;
        const currentlyLoadedGamesList = new Set(currentCache.games.map(game => {
          var _game$model3;
          return (_game$model3 = game.model) === null || _game$model3 === void 0 ? void 0 : _game$model3.name;
        }));
        for (const game of games) {
          var _game$model4;
          if (!currentlyLoadedGamesList.has((_game$model4 = game.model) === null || _game$model4 === void 0 ? void 0 : _game$model4.name)) {
            currentCache.games.push(game);
          }
        }
      },
      forceRefetch(_ref8) {
        let currentArg = _ref8.currentArg,
          previousArg = _ref8.previousArg;
        const cur = serializeWithoutPaging(getSearchResult, currentArg);
        const prev = serializeWithoutPaging(getSearchResult, previousArg);
        return cur !== prev;
      }
    }),
    getSocketLiveData: builder.query({
      queryFn: async (_ref9, _api, _extraOptions, baseQuery) => {
        let liveTableId = _ref9.liveTableId,
          clientStartType = _ref9.clientStartType,
          provider = _ref9.provider;
        if (!useCloudCasinoApis) {
          const supplier = provider === 'OnAir' ? provider : clientStartType;
          const result = await baseQuery("/casino/1/gameinfo/livedata/".concat(liveTableId.toLowerCase(), "?supplier=").concat(supplier));
          if (result.error) {
            return result;
          }
          return {
            data: result.data
          };
        }
        try {
          const providerEndpoint = provider.replace(' ', '').replace('_', '').toLowerCase();
          const response = await svsFetch("/v1/casino/providers/".concat(providerEndpoint, "/tables/").concat(liveTableId.toLowerCase()));
          const data = await response.json();
          return {
            data
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(arg, _ref0) {
        let updateCachedData = _ref0.updateCachedData,
          cacheDataLoaded = _ref0.cacheDataLoaded,
          cacheEntryRemoved = _ref0.cacheEntryRemoved;
        const liveTableId = arg.liveTableId,
          clientStartType = arg.clientStartType,
          provider = arg.provider;
        const handleUpdate = data => {
          if (!useCloudCasinoApis) {
            updateCachedData(() => data);
            return;
          }
          updateCachedData(() => {
            var _data$message;
            return data === null || data === void 0 || (_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.data;
          });
        };
        let subscription;
        let socketUrl;
        if (!useCloudCasinoApis) {
          const supplier = provider === 'OnAir' ? provider : clientStartType;
          socketUrl = "/casino/1/gameinfo/livedata/".concat(liveTableId.toLowerCase(), "?supplier=").concat(supplier);
        } else {
          const providerEndpoint = provider.replace(' ', '').replace('_', '').toLowerCase();
          socketUrl = "/api/v1/casino/providers/".concat(providerEndpoint, "/tables/").concat(liveTableId.toLowerCase());
        }
        try {
          await cacheDataLoaded; 
          if (!useCloudCasinoApis) {
            svs.core.socket.subscribe(socketUrl, handleUpdate, {}, false, true, false);
          } else {
            subscription = casinoMicroserviceSocket.subscribe(socketUrl, handleUpdate);
          }
        } catch (_unused) {
        }
        await cacheEntryRemoved;
        if (!useCloudCasinoApis) {
          svs.core.socket.unsubscribe(socketUrl, handleUpdate);
        } else if (subscription) {
          subscription.unsubscribe();
        }
      }
    }),
    getSocketJackpotData: builder.query({
      queryFn: async (_ref1, _api, _extraOptions, baseQuery) => {
        let jackpotId = _ref1.jackpotId,
          clientStartType = _ref1.clientStartType;
        if (!useCloudCasinoApis) {
          const result = await baseQuery("/casino/1/gameinfo/jackpots/".concat(jackpotId.toLowerCase(), "?supplier=").concat(clientStartType));
          if (result.error) {
            return result;
          }
          return {
            data: result.data
          };
        }
        try {
          const response = await svsFetch("/v1/casino/providers/".concat(clientStartType.replace('_', '').toLowerCase(), "/jackpots/").concat(jackpotId));
          const data = await response.json();
          return {
            data
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      },
      keepUnusedDataFor: 0,
      async onCacheEntryAdded(arg, _ref10) {
        let updateCachedData = _ref10.updateCachedData,
          cacheDataLoaded = _ref10.cacheDataLoaded,
          cacheEntryRemoved = _ref10.cacheEntryRemoved;
        const jackpotId = arg.jackpotId,
          clientStartType = arg.clientStartType;
        let socketUrl;
        if (!useCloudCasinoApis) {
          socketUrl = "/casino/1/gameinfo/jackpots/".concat(jackpotId.toLowerCase(), "?supplier=").concat(clientStartType);
        } else {
          socketUrl = "/api/v1/casino/providers/".concat(clientStartType.replace('_', '').toLowerCase(), "/jackpots/").concat(jackpotId);
        }
        const handleUpdate = data => {
          if (!useCloudCasinoApis) {
            updateCachedData(() => data);
            return;
          }
          updateCachedData(() => {
            var _data$message2;
            return data === null || data === void 0 || (_data$message2 = data.message) === null || _data$message2 === void 0 ? void 0 : _data$message2.data;
          });
        };
        let subscription;
        try {
          await cacheDataLoaded; 
          if (!useCloudCasinoApis) {
            svs.core.socket.subscribe(socketUrl, handleUpdate, {}, false, true, false);
          } else {
            subscription = casinoMicroserviceSocket.subscribe(socketUrl, handleUpdate);
          }
        } catch (_unused2) {
        }
        await cacheEntryRemoved;
        if (!useCloudCasinoApis) {
          svs.core.socket.unsubscribe(socketUrl, handleUpdate);
        } else if (subscription) {
          subscription.unsubscribe();
        }
      }
    }),
    getGamesByProvider: builder.query({
      queryFn: async (_ref11, _api, _extraOptions, baseQuery) => {
        let _ref11$providers = _ref11.providers,
          providers = _ref11$providers === void 0 ? [] : _ref11$providers,
          _ref11$count = _ref11.count,
          count = _ref11$count === void 0 ? 1000 : _ref11$count,
          _ref11$offset = _ref11.offset,
          offset = _ref11$offset === void 0 ? 0 : _ref11$offset;
        const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
        if (useLegacyJupiterApi) {
          const qs = new URLSearchParams();
          qs.append('routesDomain', encodeURIComponent('spela'));
          qs.append('count', encodeURIComponent(count));
          qs.append('offset', encodeURIComponent(offset));
          const providersQuery = Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 ? "&providers=".concat(providers.join(',')) : '';
          const result = await baseQuery("/content/3/casinosearch?".concat(qs.toString()).concat(providersQuery));
          if (result.error) {
            return result;
          }
          return {
            data: {
              error: result.data.error,
              totalCount: result.data.totalCount,
              games: result.data.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        }

        try {
          const client = svs.content.shared.getCmsClient();
          const response = await client.v1.content.casinoSearch({
            providers: Array.isArray(providers) && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 ? providers.join(',') : undefined,
            count,
            offset
          });
          return {
            data: {
              error: null,
              totalCount: response.totalCount,
              games: response.result.map(game => normalizeCardData(game, CardType.GAME))
            }
          };
        } catch (e) {
          return {
            error: {
              status: 'CUSTOM_ERROR',
              error: e.message
            }
          };
        }
      }
    })
  })
});
setGlobal('svs.components.casino_react.casinoStore.endpoints.searchApi', searchApi);

 })(window);